import React, { useEffect, useRef } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { BasicContactPerson, ContactPerson } from '@api/ringil-api.v2.tsx';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { stampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  contacts: ContactPerson[];
  value: BasicContactPerson;
  onChange: (value: ContactPerson) => void;
  fullWidth?: boolean;
  dataTestId?: string;
  dataDetailTestId?: string;
}

const InputContact: React.FC<ComponentProps> = ({ value, contacts, onChange, fullWidth = false, dataTestId, dataDetailTestId }) => {
  const dropdownWrapperRef = useRef<HTMLDivElement | null>(null);

  const optionTestIdPrefix = (() => {
    if (!dataTestId) return null;
    return dataTestId;
  })();

  useEffect(() => {
    stampDataTestIdOnDescendantRef(dropdownWrapperRef, '.p-dropdown', dataTestId);
  }, [dataTestId]);

  return (
    <div className={`flex flex-col gap-1 ${fullWidth ? 'grow' : ''} `}>
      <div ref={dropdownWrapperRef} className="w-full">
        <Dropdown
          className="w-full"
          options={contacts}
          value={value}
          dataKey={'contactEmail'}
          optionLabel="contactName"
          itemTemplate={(option: ContactPerson) => {
            const displayedValue = option?.contactName ?? option?.contactEmail ?? '';
            const slug = toTestIdSlug(displayedValue) || toTestIdSlug(option?.contactEmail) || 'unknown';
            const optionTestId = optionTestIdPrefix ? `${optionTestIdPrefix}-${slug}` : undefined;

            return <span data-testid={optionTestId}>{displayedValue}</span>;
          }}
          onChange={e => onChange(e.value)}
        />
      </div>
      <div className={'text-content-secondary text-[10px]'} data-testid={dataDetailTestId}>
        {[value?.contactEmail, value?.contactPhone].filter(t => t != null).join(', ')}
      </div>
    </div>
  );
};

export default InputContact;
